import React from "react";
import "../../styles/components/gathering-customization-form-component.css";
import "../../styles/components/image-uploads.css";

const MapTab = ({ mapImage, handleMapChange, mapPreviewUrl }) => {
  return (
    <div className="input-container">
      <h3 className="tab-title">Event Map</h3>

      <div className="input-container">
        <h3>Upload a new map image:</h3>
        <p>
          Upload your map image below. This should be a high-quality and
          readable image, since users will be able to zoom in to view map
          details. PNG, JPG, and JPEG images are supported.
        </p>

        <label className="upload-button-label" htmlFor="map-upload">
          Upload Image
        </label>

        <input
          id="map-upload"
          type="file"
          onChange={handleMapChange}
          accept="image/png,image/jpeg,image/jpg"
          className="upload-button"
        />

        {mapPreviewUrl && (
          <div>
            <p>New Image Preview:</p>
            <img
              className="map-image"
              src={mapPreviewUrl}
              alt="Map Preview"
            />
          </div>
        )}

        {mapImage && (
          <div>
            <p>Existing Image:</p>
            <img
              className="map-image"
              src={mapImage}
              alt="Existing Map"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MapTab;